import { OktaAuthOptions } from "@okta/okta-auth-js";
import { envConstants } from "./env-constants";

const oktaAuthOptions: OktaAuthOptions = {
    clientId: envConstants.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: envConstants.REACT_APP_OKTA_REDIRECT_URL,
    issuer: envConstants.REACT_APP_OKTA_ISSUER,
    scopes: ["openid", "profile", "email", "offline_access"],
};

const map = {
    initializationOptions: {
        accessToken: envConstants.REACT_APP_MAP_ACCESS_TOKEN,
        style: envConstants.REACT_APP_MAP_STYLE,
        center: [0, 0] as [number, number],
        attributionControl: false,
        zoom: 1,
    },

    openWeatherMapKey: envConstants.REACT_APP_MAP_OPEN_WEATHER_MAP_KEY,
    accumulatedPrecipitationColorPalette: envConstants.REACT_APP_MAP_ACCUMULATED_PRECIPITATION_COLOR_PALETTE,
};

export const config = {
    oktaAuthOptions,
    map,
};
